import type { WaitingUserInfo } from 'api/types';

export const getWaitingUserDisplayName = (
    user: Pick<WaitingUserInfo, 'firstName' | 'lastName' | 'userName'>,
): string => {
    const fullName = [user.firstName, user.lastName].filter(Boolean).join(' ').trim();

    return fullName || user.userName;
};
